// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__sUGr1","inner":"Footer_inner__33xav","nextIcon":"Footer_nextIcon__27FAA","innerLeft":"Footer_innerLeft__2aNnP"};